import { PHASE_PRODUCTION_BUILD } from 'next/constants';

export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const DEFAULT_LOG_LEVEL: LogLevel = 'debug';
const DEFAULT_BUILD_LOG_LEVEL: LogLevel = 'debug';

const isBuildPhase = () => process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD;

/**
 * `LOG_LEVEL` is inlined by `next.config.js` `env` at build time, so on PRD it is `warn` for both
 * the build and the runtime. `BUILD_LOG_LEVEL` is only read while `next build` runs, which lets
 * SSG logging stay verbose without affecting the runtime server.
 */
export const resolveLogLevel = (): string =>
  isBuildPhase()
    ? process.env.BUILD_LOG_LEVEL || DEFAULT_BUILD_LOG_LEVEL
    : process.env.LOG_LEVEL || DEFAULT_LOG_LEVEL;
